<template>
  <div class="add_episode_box">
    <form @submit.prevent="onFormSubmit" :disabled="pending">
      <app-input
          :error="errors.items.find(el => el.field === 'name')"
          :label="translations.name"
          name="name"
          :disabled="pending"
          v-model="form.name"
      />
      <app-settings-input
          :error="errors.items.find(el => el.field === 'description')"
          :label="translations.description1"
      >
        <app-textarea
            name="description"
            rows="3"
            :disabled="pending"
            v-model="form.description"
        />
      </app-settings-input>
      <app-input
          class="field_left"
          :error="errors.items.find(el => el.field === 'seriesNumber')"
          :label="translations.seasonNumber"
          name="seriesNumber"
          :disabled="pending"
          v-model="form.seriesNumber"
      />
      <app-input
          class="field_right"
          :error="errors.items.find(el => el.field === 'episodeNumber')"
          :label="translations.episodeNumber"
          name="episodeNumber"
          :disabled="pending"
          v-model="form.episodeNumber"
      />
      <p class="field">
        <input class="btn btn_next" type="submit" :value="translations.saveEpisode" :disabled="pending">
      </p>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isNotNaN } from 'ramda-adjunct'
import SidebarDropdown from '../Common/Sidebar/SidebarDropdown'

export default {
  name: 'sidebar-add-episode',
  components: {
    SidebarDropdown
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        seriesNumber: '',
        episodeNumber: ''
      }
    }
  },
  computed: {
    ...mapState({
      episode: state => state.episodes.episode,
      pending: state => state.episodes.pending.episode
    }),
    translations() {
      return {
        name: this.$gettext('Název *'),
        description1: this.$gettext('Popis 1'),
        seasonNumber: this.$gettext('Série číslo'),
        episodeNumber: this.$gettext('Epizoda číslo'),
        saveEpisode: this.$gettext('Uložit epizodu'),
      }
    }
  },
  methods: {
    ...mapActions([
      'getEpisodes', 'createEpisode', 'appShowErrors'
    ]),
    async onFormSubmit(e) {
      this.errors.clear()

      await this.$validator.validateAll()
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg))
        return
      }

      const { elements } = e.target
      const seriesNum = parseInt(elements.namedItem('seriesNumber').value, 10)
      const episodesNum = parseInt(elements.namedItem('episodeNumber').value, 10)
      const result = await this.createEpisode({
        data: {
          show: this.item._id,
          name: elements.namedItem('name').value,
          description: elements.namedItem('description').value,
          seriesNumber: (isNotNaN(seriesNum) && seriesNum >= 1) ? seriesNum : 1,
          episodeNumber: (isNotNaN(episodesNum) && episodesNum >= 1) ? episodesNum : null
        }
      }).catch(err => err.response)

      const apiErrors = result.data.error
      if (apiErrors && apiErrors.length) {
        this.errors.add(apiErrors.map(v => ({ field: v.path, msg: v.message })))
        this.appShowErrors(apiErrors.map(v => v.message))
      }

      if (result.status === 201) {
        e.target.reset()
        this.$validator.reset()
        this.$emit('refreshEpisodes')
      }
    }
  }
}
</script>
